module.exports = __webpack_public_path__ + "assets/images/01_fd74e5624d2bf8af2bcdf3b120cd0aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/01.png
// module id = 154
// module chunks = 0